import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Made with 🔥 by Imran Hasan Rahi</div>;
}

export default Footer;
